// Modules
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

// Constants
import { readStoredLocale } from '@/constants/locale-constants';

export const OPTIONS_STORE_LOCALE = {
  ACTIONS: {
    SET_LOCALE: 'locale/setLocale'
  },
  GETTERS: {
    CURRENT_LOCALE: 'locale/currentLocale'
  }
};

export default {
  namespaced: true,
  state: {
    locale: readStoredLocale()
  },
  actions,
  getters,
  mutations
};
